import {
  TextField,
  FormControlLabel,
  Checkbox,
  FormGroup,
  InputAdornment,
  ListItem,
  ListItemIcon,
  List,
  FormLabel,
  ListItemText,
  Grid,
} from "@mui/material";
import React from "react";

import HelperText from "../../../../components/feedback/helper-text";
import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import { getPropertieObjectById } from "../helper";

export default class NewDocumentUpload {
  static DisplayTab(props) {
    const {
      onChange,
      state,
      onPropertieChange,
      disabled,
      onCheckChange,
      error,
    } = props;

    const label = getUnitPropertie(state, "label") || "";
    const required = getUnitPropertie(state, "required");
    const isRequired = getUnitPropertie(state, "isRequired");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            disabled={disabled}
            onChange={onChange}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            disabled={disabled}
            onChange={(event) => onPropertieChange(event)}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            disabled={disabled}
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="isRequired"
                  onChange={(event) => onCheckChange(event)}
                  value={isRequired}
                  checked={isRequired || false}
                />
              }
              label={language.propertieRequired}
            />
          </FormGroup>
        </Grid>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="required"
            variant="outlined"
            id="standard-basic"
            label={language.propertieRequired}
            value={required || ""}
            disabled={!isRequired}
            error={!!getPropertieObjectById(error, "required")}
            fullWidth
          />
          {error && getPropertieObjectById(error, "required") && (
            <HelperText>{language.requirederror}</HelperText>
          )}
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      onPropertieChange,
      state,
      documentTemplates,
      docTypes,
      handlePropertieChangeDocumentType,
    } = props;

    const documentType = getUnitPropertie(state, "documentType");
    const template = getUnitPropertie(state, "template");

    const [checked, setChecked] = React.useState([]); // <- ADICIONE ISTO

    const handleToggle = (value) => () => {
      const currentIndex = checked.indexOf(value);
      const newChecked = [...checked];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setChecked(newChecked);
    };

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <FormLabel component="legend">{language.documentType}</FormLabel>
          <List dense>
            {docTypes &&
              docTypes?.content?.map((doc) => {
                return (
                  <ListItem key={doc.id} button onClick={handleToggle(doc)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(doc) !== -1}
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText primary={doc.name} />
                  </ListItem>
                );
              })}
          </List>
        </Grid>

        <Grid item size={12}>
          <FormLabel component="legend">{language.template}</FormLabel>
          <List dense>
            {documentTemplates &&
              documentTemplates?.content?.map((temp) => {
                return (
                  <ListItem key={temp.id} button onClick={handleToggle(temp)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        checked={checked.indexOf(temp) !== -1}
                        tabIndex={-1}
                        disableRipple
                      />
                    </ListItemIcon>
                    <ListItemText primary={temp.name} />
                  </ListItem>
                );
              })}
          </List>
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
